import { Flex, For } from 'shared';

import {
  JournalFilterButton,
  JournalFilterSectionLabel,
  JournalFilterLabel,
  useJournalChallengeFilterContext,
  JOURNAL_CHALLENGE_FILTERS,
  useJournalFilterContext,
} from 'features/journal';

export const JournalFilterByChallenge = () => {
  const {
    handleAllChallengesClick,
    handleChallengeClick,
    journalChallengeFilterState,
    currentSprintChallenges,
    handleWithoutChallengesClick,
  } = useJournalChallengeFilterContext();
  const { queryParams } = useJournalFilterContext();

  return (
    <>
      <JournalFilterLabel>By Challenge</JournalFilterLabel>
      <Flex gap="8px">
        <JournalFilterButton
          isActive={
            !!journalChallengeFilterState[JOURNAL_CHALLENGE_FILTERS.ALL]
          }
          onClick={handleAllChallengesClick}
          disabled={!!(currentSprintChallenges.length === 0)}
          dataTestid="journal-sidebar-filter-all-challenges"
        >
          All challenges
        </JournalFilterButton>
        <JournalFilterButton
          isActive={queryParams.withoutChallenges}
          onClick={handleWithoutChallengesClick}
          dataTestid="journal-sidebar-filter-without-challenge"
        >
          Without challenge
        </JournalFilterButton>
      </Flex>
      {Boolean(currentSprintChallenges.length) && (
        <JournalFilterSectionLabel>
          Current challenges
        </JournalFilterSectionLabel>
      )}
      <Flex gap="8px" flexWrap="wrap">
        <For each={currentSprintChallenges}>
          {({ title, challengeId }) => (
            <JournalFilterButton
              key={challengeId}
              isActive={
                !!journalChallengeFilterState[
                  `${JOURNAL_CHALLENGE_FILTERS.CURRENT_CHALLENGES}-${challengeId}`
                ]
              }
              onClick={() => handleChallengeClick(challengeId)}
              dataTestid="journal-sidebar-current-challenge"
            >
              {title}
            </JournalFilterButton>
          )}
        </For>
      </Flex>
    </>
  );
};
